export default __webpack_public_path__ + "static/nick-9f770b23e9167ad505f243f447f0f88e.png";